import { render, staticRenderFns } from "./acessoNegado.vue?vue&type=template&id=ad617da2&scoped=true&"
import script from "./acessoNegado.vue?vue&type=script&lang=js&"
export * from "./acessoNegado.vue?vue&type=script&lang=js&"
import style0 from "./acessoNegado.vue?vue&type=style&index=0&id=ad617da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad617da2",
  null
  
)

export default component.exports